import { Fragment } from "react/jsx-runtime";
import { MessageArchive, NotificationTitle } from "../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { setNotificationActive } from "../../../../ReduxToolkit/Reducers/Messenger/MainSidebar";
import { dynamicImage, Image } from "../../../../Utils";
import SearchNotFoundClass from "../../../CommonComponents/SearchNotFound/SearchNotFoundClass";
import CommonLeftHeading from "./Common/CommonLeftHeading";

const Notification = () => {
  const dispatch = useAppDispatch();
  const { notificationActive } = useAppSelector((state) => state.mainSidebar);
  return (
    <Fragment>
      <CommonLeftHeading title={NotificationTitle} sunTitle={MessageArchive} />
      <ul className="chat-main" id="draggableMultiple">
        {notificationActive.length !== 0 ? (
          notificationActive.map((item, index) => (
            <li className="border-0 pb-0 pb-0" key={index}>
              <div className="notification-close">
                <div className="chat-box notification">
                  <div className={`profile ${item.class}`}>{item.image ? <Image className="bg-img" src={dynamicImage("contact/1.jpg")} alt="Avatar" /> : <span>{item.word}</span>}</div>
                  <div className="details">
                    <h4>{item.title}</h4>
                    <h5>{item.text}</h5>
                    <p>{"I would suggest you discuss this further with the advertising team."}</p>
                  </div>
                  <div className="date-status">
                    <div className="btn-close" onClick={() => dispatch(setNotificationActive(index))} />
                  </div>
                </div>
              </div>
            </li>
          ))
        ) : (
          <SearchNotFoundClass word="Sorry, Not Found Any Notification." />
        )}
      </ul>
    </Fragment>
  );
};

export default Notification;
